import { createContext, useContext } from "react";

import type { EmptyStateViewModel } from "./types-empty-state";

export const EmptyStateContext = createContext<EmptyStateViewModel | null>(null);

export function useEmptyStateContext(): EmptyStateViewModel {
  const context = useContext(EmptyStateContext);
  if (!context) throw new Error("EmptyState.* deve ser usado dentro de EmptyState.Root");
  return context;
}
